var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeleteBlack(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_908_40467",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 21
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.269531,
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_908_40467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.08333 17.3535C5.66667 17.3535 5.3125 17.2077 5.02083 16.916C4.72917 16.6243 4.58333 16.2702 4.58333 15.8535V5.27018H3.75V4.02018H7.5V3.29102H12.5V4.02018H16.25V5.27018H15.4167V15.8535C15.4167 16.2702 15.2708 16.6243 14.9792 16.916C14.6875 17.2077 14.3333 17.3535 13.9167 17.3535H6.08333ZM14.1667 5.27018H5.83333V15.8535C5.83333 15.923 5.85778 15.9821 5.90667 16.031C5.955 16.0793 6.01389 16.1035 6.08333 16.1035H13.9167C13.9722 16.1035 14.0278 16.0757 14.0833 16.0202C14.1389 15.9646 14.1667 15.9091 14.1667 15.8535V5.27018ZM7.83333 14.4368H9.08333V6.93685H7.83333V14.4368ZM10.9167 14.4368H12.1667V6.93685H10.9167V14.4368ZM5.83333 5.27018V16.1035V15.8535V5.27018Z",
    fill: "#252525"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteBlack);
export default __webpack_public_path__ + "static/media/delete-black.3d69706d0906cb6129dbf84e04d3d480.svg";
export { ForwardRef as ReactComponent };